import graphql from "babel-plugin-relay/macro";
import { readInlineData } from "react-relay";

import { ScheduleOption } from "../hooks/useGetScheduleSwitcherOptions";
import { departmentToScheduleOption_department$key } from "./__generated__/departmentToScheduleOption_department.graphql";

export const departmentToScheduleOption = (
  departmentRef: departmentToScheduleOption_department$key | null
): ScheduleOption => {
  const department = readInlineData(
    departmentToOptionFragmentString,
    departmentRef
  );
  return {
    type: "department" as const,
    label: department?.name || "",
    id: department?.id || "",
    slug: department?.slug || "",
    departmentType: department?.type || "GOLF",
  };
};

const departmentToOptionFragmentString = graphql`
  fragment departmentToScheduleOption_department on Department @inline {
    type
    id
    slug
    name
  }
`;
